<form [formGroup]="form">
    <div class="modal-header">
        <h4 class="modal-title">Skift bruger</h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">

        <div class="row">
            <label for="officeId" class="col-sm-4 col-form-label col-form-label-sm">Kontor</label>
            <div class="col-sm-8">
                <select class="form-select form-select-sm" id="officeId" (change)="onOfficeSelect($event.target.value)" formControlName="officeId">
                    <option disabled selected value="-1"> -- Vælg kontor -- </option>
                    <option *ngFor="let office of offices" [value]="office.kontorId">{{office?.kontornavn}} - {{office?.kontorId}}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <label for="mid" class="col-sm-4 col-form-label col-form-label-sm">Bruger</label>
            <div class="col-sm-8">
                <select class="form-select form-select-sm" id="mid" formControlName="mid">
                    <option disabled selected value="-1"> -- Vælg bruger -- </option>
                    <option *ngFor="let user of users" [value]="user.cardId">{{user?.navn}} - {{user?.cardId}}</option>
                </select>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <div class="btn-toolbar float-end mb-2">
                <button (click)="onDismiss()" class="btn btn-primary me-2" type="button">Annuller</button>
                <button (click)="onOk(form.controls['mid'].value)" class="btn btn-primary me-2" type="submit">Skift</button>
        </div>
    </div>

</form>
